var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('BackToTop'),(!_vm.sysUpdate)?_c('router-view'):_c('div',{staticClass:"error-page"},[_c('img',{attrs:{"width":"480","height":"400","src":require("@/assets/img/503.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }